import React from "react"
import { Box } from "@chakra-ui/react"

export function Main({ children }) {
  return (
    <Box as="main" flex="1" mt="50px">
      {children}
    </Box>
  )
}
